import { createApp } from 'vue';
import ProductItemApp from '@/app/front/ProductItemApp.vue';
import { AppPlugin } from '@/services/app-plugin';

const selector = '#product-app';
S.import('@main')
  .then(() => u.domready())
  .then(() => {
    const app = createApp(ProductItemApp);

    app.use(AppPlugin);
    app.mount(selector);
  });
